<!--
	TreeViewer.svelte

    Hosted in <SearchPanels> component

-->

<script>
    import TreeViewerNode from './TreeViewerNode.svelte';

    export let tree;
    export let onNodeClick;
    
</script>

<style>
    .tree-viewer {
        width: 500px;
        font-size: 1em;
    }
</style>

<!-- this is now recursive in TreeViewerNode itself -->
<!-- using syntax: <svelte:self level={level+1} {node} {onNodeClick} /> -->

<div class="tree-viewer">
    {#if tree}
        {#each tree as node}
            <TreeViewerNode level={0} {node} {onNodeClick}/>
        {/each}
    {/if}
</div>
